import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface ISponsorsPayload {
  lang: string;
}

export const sponsorSlice = createApi({
  reducerPath: 'sponsor',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getSponsors'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Sponsors'],
  endpoints: (builder) => ({
    getSponsors: builder.query<IAnyResponse, ISponsorsPayload>({
      query: (payload) => ({
        url: `/sponsors`,
        method: 'GET'
      })
    })
  })
});

export const { useGetSponsorsQuery } = sponsorSlice;
